export default __webpack_public_path__ + "static/media/94C.35c0a090.jpg";